import React from "react";
import {
  SelectorContent,
  SelectorListItem,
  SelectorValueTrigger,
} from "./Selector";
import * as Select from "@radix-ui/react-select";
import { useIntl } from "react-intl";

type OrgUserEditRoleType = "ADMIN" | "READ_ONLY";

export function OrgUserEditRoleSelect(props: {
  selectedRole: OrgUserEditRoleType | undefined;
  onSelectRole: (role: OrgUserEditRoleType) => void;
}) {
  const intl = useIntl();

  const labels = {
    READ_ONLY: intl.formatMessage({
      defaultMessage: "Read Only",
      description: "WorkspaceRole READ_ONLY label",
    }),
    ADMIN: intl.formatMessage({
      defaultMessage: "Admin",
      description: "WorkspaceRole ADMIN label",
    }),
  };

  return (
    <Select.Root
      required
      value={props.selectedRole}
      onValueChange={(value) =>
        props.onSelectRole(value as OrgUserEditRoleType)
      }
    >
      <SelectorValueTrigger
        valueLabel={props.selectedRole ? labels[props.selectedRole] : ""}
        mode="large"
      />
      <Select.Portal>
        <SelectorContent>
          <SelectorListItem
            data={{
              id: "ADMIN",
              name: labels.ADMIN,
            }}
            selectedId={props.selectedRole}
          />
          <SelectorListItem
            data={{
              id: "READ_ONLY",
              name: labels.READ_ONLY,
            }}
            selectedId={props.selectedRole}
          />
        </SelectorContent>
      </Select.Portal>
    </Select.Root>
  );
}
